import { API_PATHS, REQUEST_METHODS, ROUTE_PARAMS, interpolatePathParams } from '@futrli/shared-services';

import {
  BusinessInsightSchedule,
  InsightScheduleCreateRequest,
  InsightScheduleUpdateRequest,
  ListBusinessInsightSchedules
} from '@futrli-sdk/predict';

import { makeRequestWithResponse } from './shared';

/**
 * Fetches insights schedules
 */
export const fetchSchedules = async (
  workspaceId: string,
  organisationId: string
): Promise<ListBusinessInsightSchedules> => {
  const path = interpolatePathParams(API_PATHS.BUSINESS_INSIGHTS_SCHEDULE, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });

  return makeRequestWithResponse<ListBusinessInsightSchedules>({ url: path, method: REQUEST_METHODS.GET });
};

/**
 * Creates insights schedule 
 */
export const createSchedule = async (
  workspaceId: string,
  organisationId: string,
  data: Partial<InsightScheduleCreateRequest>
): Promise<InsightScheduleCreateRequest> => {
  const path = interpolatePathParams(API_PATHS.BUSINESS_INSIGHTS_SCHEDULE, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });

  return makeRequestWithResponse<BusinessInsightSchedule>({ url: path, method: REQUEST_METHODS.POST, data });
};

/**
 * Updates insights schedule 
 */
export const updateSchedule = async (
  workspaceId: string,
  organisationId: string,
  insightsScheduleId: string,
  data: Partial<InsightScheduleUpdateRequest>
): Promise<BusinessInsightSchedule> => {
  const path = interpolatePathParams(API_PATHS.BUSINESS_INSIGHTS_SCHEDULE_BY_ID, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.INSIGHTS_SCHEDULE_ID]: insightsScheduleId
  });

  return makeRequestWithResponse<BusinessInsightSchedule>({ url: path, method: REQUEST_METHODS.PUT, data });
};

/**
 * Deletes insights schedule 
 */
export const deleteSchedule = async (
  workspaceId: string,
  organisationId: string,
  insightsScheduleId: string
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.BUSINESS_INSIGHTS_SCHEDULE_BY_ID, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.INSIGHTS_SCHEDULE_ID]: insightsScheduleId
  });

  return makeRequestWithResponse<void>({ url: path, method: REQUEST_METHODS.DELETE });
};

/**
 * Deletes all insights schedules
 */
export const deleteAllSchedules = async (workspaceId: string, organisationId: string): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.BUSINESS_INSIGHTS_SCHEDULE_REMOVE_ALL, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });

  return makeRequestWithResponse<void>({ url: path, method: REQUEST_METHODS.DELETE });
};
